import {
  PT_MASTERCATEGORY,
  PT_PRODUCT_LIST,
} from "../../../../routes/stack/paths/pt-home";
import { api_UpdateIsFavouriteForMerchant } from "../../../../connection/api/api-home";
import { CSP, ENCRYPT_STORAGE_SESSION } from "../../../../config/config";
import { faHouseLock, faUtensils } from "@fortawesome/free-solid-svg-icons";
import { Api_DrawAnalyticalPath } from "../../../../connection/api/api-Machine-Learning";
import { set_dto_Merchant } from "../../../../classes/dto-setters/dto-setter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { F_Fammily, Font } from "../../../../util/config-fonts";
import { dto_Customer } from "../../../../classes/dto-customer";
import { dto_common } from "../../../../classes/dto-common";
import React from "react";
import "../../../../styles/css/pg-home-merchant-card.css";

export default class MerchantCard extends React.PureComponent {
  handleHeartClick = async (MID, event) => {
    event.stopPropagation();
    const newIsTrue = !this.props.data.IsFavourite;
    let response = await api_UpdateIsFavouriteForMerchant(MID, newIsTrue);
    if (response === "SUCCESS") {
      this.props.refreshHome();
    }
  };

  render() {
    let data = this.props.data;
    if (
      CSP === "DT" &&
      data.MUD !== "" &&
      data.MUD !== "N/A" &&
      data.MUD !== null
    ) {
      data.IL = data.MUD;
    } else if (data.IL === "" || data.IL === "N/A") {
      data.IL = dto_common.DefaultImageUrl;
    }

    let MerchantStatusText = data.MS;

    if (data.MS !== "CLOSED FOR ORDERS") {
      if (data.DineType === 4) {
        MerchantStatusText += " - DELIVERY ONLY";
      } else if (data.DineType === 3) {
        MerchantStatusText += " - TAKEAWAY ONLY";
      }
    } else if (data.MS === "CLOSED FOR ORDERS") {
      MerchantStatusText = "CLOSED";
    }

    const HeartColor = data.IsFavourite ? "red" : "lightgrey";

    return (
      <div
        id={data.MID + "MerchantCard"}
        onClick={() => {
          this.MerchantClick(data);
        }}
        className="fadeInUp animated pgHomeMerchantCard"
        data-wow-duration="300ms"
        data-wow-delay="0ms"
        style={{ position: "relative" }} 
      >
        <img
          src={data.IL}
          style={{ width: "100%", height: 180 }}
          alt="Error"
          onError={(e) => {
            e.currentTarget.src = dto_common.DefaultImageUrl;
          }}
        />
        {dto_Customer.CSID > 0 ? (
          <div
            style={{
              display: HeartColor === "red" ? "block" : "none",
              position: "absolute",
              right: 20,
              bottom: 50,
              color: HeartColor,
            }}
          >
            <i className="bi bi-heart-fill" />
          </div>
        ) : null}

        <div
          style={{
            position: "absolute",
            left: 5,
            right: "none",
            borderRadius: 0,
            border: "none",

            top: 20,
            backgroundColor: data.IO === true ? "green" : "red",
            paddingTop: 3,
            paddingBottom: 3,
            paddingLeft: 5,
            paddingRight: 15,
            fontFamily: Font.Description,
          }}
        >
          <p
            style={{
              color: "white",
              padding: 0,
              fontSize: Font.SmallDescription,
              margin: 0,
              fontWeight: "bold",
            }}
          >
            {data.IO === true ? (
              <FontAwesomeIcon
                icon={faUtensils}
                style={{ marginRight: "10px" }}
              />
            ) : (
              <FontAwesomeIcon
                icon={faHouseLock}
                style={{ marginRight: "10px" }}
              />
            )}

            {MerchantStatusText}
          </p>
        </div>

        {data.MerchantPromoText !== "" ? (
          <div
            style={{
              position: "absolute",
              left: 5,
              top: 30,
              backgroundColor: "#27ae60",
              paddingTop: 3,
              paddingBottom: 3,
              paddingLeft: 5,
              paddingRight: 15,
            }}
          >
            <p
              style={{
                color: "white",
                padding: 0,
                fontSize: Font.Description,
                margin: 10,
              }}
            >
              {data.MerchantPromoText}
            </p>
          </div>
        ) : null}

        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              flex: "60%",
              margin: 0,
              lineClamp: 2,
              WebkitLineClamp: 2,
              fontSize: 14,
              fontFamily: F_Fammily.Medium,
              marginRight: "3%",
            }}
          >
            {data.Merchant}
          </div>
          <div
            style={{
              flex: "40%",
              textAlign: "right",
              display: data.AR > 0 ? "block" : "none",
            }}
          >
            <div>
              <i className="bi bi-hand-thumbs-up-fill" />
              <span style={{ fontSize: 14, marginLeft: "5px" }}>
                {data.AR} %
              </span>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div
            style={{
              margin: 0,
              lineClamp: 2,
              WebkitLineClamp: 2,
              fontSize: Font.SmallDescription,
              display: "block",
            }}
          >
            {data.Add1}
          </div>
        </div>
      </div>
    );
  }

  async MerchantClick(rs) {
    rs.CATID = 0;
    this.props.onScroll();
    ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
    await Api_DrawAnalyticalPath(42, rs.MID);
    if (CSP === "MK") {
      rs.MT = "GR";
    }
    await set_dto_Merchant(rs);
    if (rs.MT.toUpperCase() === "GR" || rs.MT.toUpperCase() === "AF") {
      this.props.navigate(PT_MASTERCATEGORY);
    } else {
      this.props.navigate(
        PT_PRODUCT_LIST.replace(":navPage", "none").replace(":isSec", "false")
      );
    }
  }
}
